import React from 'react'
import Img from '../../../../../../src/components/shared/Img'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const Partners = ({ data }) => {
  return (
    <div
      className="w-content gap-x-primary col-span-full grid grid-cols-4 lg:grid-cols-12 "
      id="partners"
      data-testid="scam-partners-section"
    >
      <div
        className="col-span-full lg:col-span-10 lg:col-start-2"
        data-testid="scam-partners-content"
      >
        <div
          className="flex flex-col items-center lg:flex-row lg:justify-around"
          data-testid="scam-partners-list"
        >
          {data.map((item, index) =>
            item.isWidget ? (
              <div
                className="mb-10 lg:mb-0"
                data-testid="scam-partners-item"
                key={index}
              >
                <item.component />
              </div>
            ) : (
              <Img
                key={index}
                className={classNames(
                  { 'mb-10': index !== data.length - 1 },
                  item.height ? item.height : 'h-16',
                  'w-52 lg:mb-0'
                )}
                dataTestId="scam-partners-item"
                src={item.src}
                alt={item.alt}
                layout="fill"
                imgClassName="object-contain"
                priority
              />
            )
          )}
        </div>
      </div>
    </div>
  )
}

export default Partners

Partners.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string,
    })
  ),
}
